import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AnalyticsTopResultsActivityLoadAction } from '../../domains/analyticsTopResultsActivity/actions.types';
import { CampaignTopThreadsLoadFulfilledAction } from '../../domains/campaignTopThreads/actions.types';
import { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';
import { LeadershipThemeTopThreadsLoadFulfilledAction } from '../../domains/leadershipThemeTopThreads/actions.types';
import { NetworkThemeTopThreadsLoadFulfilledAction } from '../../domains/networkThemeTopThreads/actions.types';
import { NetworkTopAnnouncementsLoadFulfilledAction } from '../../domains/networkTopAnnouncements/actions.types';
import { NetworkTopGroupsLoadFulfilledAction } from '../../domains/networkTopGroups/actions.types';
import { NetworkTopThemesLoadFulfilledAction } from '../../domains/networkTopThemes/actions.types';
import { NetworkTopThreadStartersLoadFulfilledAction } from '../../domains/networkTopThreadStarters/actions.types';
import { NetworkTopThreadsLoadFulfilledAction } from '../../domains/networkTopThreads/actions.types';

import { AnalyticsTopResultsEntitiesLifecycle } from './types';

export type AnalyticsTopResultsAction =
  | AnalyticsTopResultsActivityLoadAction
  | EmployeesTopThreadsLoadFulfilledAction
  | CampaignTopThreadsLoadFulfilledAction
  | LeadershipThemeTopThreadsLoadFulfilledAction
  | NetworkTopThreadStartersLoadFulfilledAction
  | NetworkTopThemesLoadFulfilledAction
  | NetworkTopGroupsLoadFulfilledAction
  | NetworkThemeTopThreadsLoadFulfilledAction
  | NetworkTopAnnouncementsLoadFulfilledAction
  | NetworkTopThreadsLoadFulfilledAction;

const initialState: AnalyticsTopResultsEntitiesLifecycle = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AnalyticsTopResultsEntitiesLifecycle, AnalyticsTopResultsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'LEADERSHIP_THEME_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THEMES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_THEME_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    default:
      return state;
  }
};

export default reducer;
